module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/tank-available.57dfe5cd.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/tank-available.png
// module id = 969
// module chunks = 16